import React, { useState, useEffect, useCallback } from "react";
import { auth } from "../../firebase";
import { signOut } from "firebase/auth";
import styled from "styled-components";
import DrawerSiniflarim from "./Drawers/DrawerSiniflarim";
import DrawerPrivateStudents from "./Drawers/DrawerPrivateStudents";
import DrawerDokumanEkle from "./Drawers/DrawerDokumanEkle";
import DrawerDokumanAra from "./Drawers/DrawerDokumanAra";
import { getDocs, query, collection, where, limit } from "firebase/firestore";
import { db } from "../../firebase";
import {
  NameBarUp,
  Name,
  Avatar,
  NameBarDown,
  NameBar,
  Description,
  Main,
  ObjectBar,
  Text,
  Button,
  ButtonBar,
  DivFlex,
  DivFlex1,
} from "../student/studentPanel";
import { Container } from "../../style/global/styledComponents/Containers";
import DrawerKonularim from "../student/Drawers/studentDrawerKonularim";

function TeacherPaneli() {
  const [user, setUser] = useState(null);
  const [avatarUrl, setAvatarUrl] = useState(null);

  // ✅ Kullanıcı verisi ve avatar yükleme (localStorage cache ile)
  useEffect(() => {
    const cachedUser = localStorage.getItem("teacherUser");
    if (cachedUser) {
      const parsedUser = JSON.parse(cachedUser);
      setUser(parsedUser);
      if (parsedUser?.userData?.avatar) {
        setAvatarUrl(
          `${process.env.PUBLIC_URL}/avatars/avatar${parsedUser.userData.avatar}.png`
        );
      }
      return;
    }

    const currentUser = auth.currentUser;
    if (!currentUser) return;

    const q = query(
      collection(db, "users"),
      where("uid", "==", currentUser.uid),
      limit(1)
    );

    const getUserData = async () => {
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        const userData = doc.data();
        setUser(userData);
        localStorage.setItem("teacherUser", JSON.stringify(userData));

        if (userData?.userData?.avatar) {
          setAvatarUrl(
            `${process.env.PUBLIC_URL}/avatars/avatar${userData.userData.avatar}.png`
          );
        }
      });
    };

    getUserData();
  }, []);

  // ✅ Aktif panel localStorage'dan yükleniyor
  const [activeDiv, setActiveDiv] = useState(() => {
    const storedActiveDiv = localStorage.getItem("teacherActiveDiv");
    return storedActiveDiv ? parseInt(storedActiveDiv, 10) : 1;
  });

  const handleSignOut = useCallback(() => {
    // ✅ Çıkışta localStorage temizle
    localStorage.removeItem("teacherUser");
    localStorage.removeItem("teacherActiveDiv");
    signOut(auth);
  }, []);

  const handleButtonClick = (divNumber) => {
    setActiveDiv(divNumber);
    localStorage.setItem("teacherActiveDiv", divNumber);
  };

  return (
    <Container>
      <NameBarUp>
        <NameBar>
          <Avatar>
            {avatarUrl && (
              <img
                src={avatarUrl}
                alt="Avatar"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            )}
          </Avatar>
          <NameBarDown>
            <Name>{user && <p>{user.userData.displayName}</p>}</Name>
            <Description>
              {user && <p>{user.userData.selfIntroduction}</p>}
            </Description>
          </NameBarDown>
        </NameBar>
      </NameBarUp>
      <Main>
        <ButtonBar>
          <DivFlex1 style={{ marginBottom: "1.5rem" }}>
            <Text>Hoş Geldiniz</Text>
          </DivFlex1>
          <DivFlex>
            <Button onClick={() => handleButtonClick(1)}>Sınıflarım</Button>
          </DivFlex>
          <DivFlex>
            <Button onClick={() => handleButtonClick(2)}>Öğrencilerim</Button>
          </DivFlex>
          <DivFlex>
            <Button onClick={() => handleButtonClick(3)}>Döküman Ekle</Button>
          </DivFlex>
          <DivFlex>
            <Button onClick={() => handleButtonClick(4)}>Döküman Ara</Button>
          </DivFlex>
          <DivFlex>
            <Button onClick={() => handleButtonClick(5)}>Konularım</Button>
          </DivFlex>
          <DivFlex>
            <Button onClick={handleSignOut}>Çıkış</Button>
          </DivFlex>
        </ButtonBar>

        {/* ✅ Drawer'lar CSS display ile gizleniyor, unmount olmuyor */}
        <ObjectBar>
          <div style={{ display: activeDiv === 1 ? "block" : "none" }}>
            <DrawerSiniflarim />
          </div>
          <div style={{ display: activeDiv === 2 ? "block" : "none" }}>
            <DrawerPrivateStudents />
          </div>
          <div style={{ display: activeDiv === 3 ? "block" : "none" }}>
            <DrawerDokumanEkle />
          </div>
          <div style={{ display: activeDiv === 4 ? "block" : "none" }}>
            <DrawerDokumanAra />
          </div>
          <div style={{ display: activeDiv === 5 ? "block" : "none" }}>
            <DrawerKonularim />
          </div>
        </ObjectBar>
      </Main>
    </Container>
  );
}

export default TeacherPaneli;
